import React from "react";
import CaseStudyPageSection from "../../components/CaseStudyPageSection";
import InnerBanner from "../../components/InnerBanner";

const CaseStudiesPage = () => {
  return (
    <>
      <InnerBanner title="Case Studies"/>
      <CaseStudyPageSection/>
    </>
  );
};

export default CaseStudiesPage;
